export const NdcColors = {
  borderColor: 'border-blue-600',
  backgroundColor: 'bg-blue-600',
  textColor: 'text-blue-800',
};
